import { FileReader, FileWriter } from '@/platform'
import FontSetting from './FontSetting'
import PersonSetting from './PersonSetting'

class BubblePerson {
    /**
     * 气泡用人物设置列表
     */
    public PersonList: PersonSetting[] = []

    readBin(reader: FileReader): void {
        this.PersonList = []
        const len = reader.readInt()
        for (var i = 0; i < len; i++) {
            let perset = new PersonSetting(reader)
            this.PersonList.push(perset)
        }
    }

    writeBin(writer: FileWriter): void {
        writer.writeInt(this.PersonList.length)
        for (let i = 0; i < this.PersonList.length; i++) {
            const perset = this.PersonList[i]
            perset?.writeBin(writer)
        }
    }

    readVersionedOui(reader: FileReader): void {
        this.PersonList = []
        const len = reader.readInt()
        for (var i = 0; i < len; i++) {
            let perset = new PersonSetting()
            perset.readVersionedOui(reader.readObj(reader.readInt()))
            this.PersonList.push(perset)
        }
    }

    writeVersionedOui(writer: FileWriter): void {
        writer.writerIntLength()

        writer.writeInt(this.PersonList.length)
        for (let i = 0; i < this.PersonList.length; i++) {
            const perset = this.PersonList[i]
            perset.writeVersionedOui(writer)
        }

        writer.writerLength()
    }

    /**
     * 写入 Game.bin 中 SystemData 末尾的气泡人物和字体高度设置。
     */
    writeGameBin(writer: FileWriter, engineVersion: number, fontSettings: FontSetting[] = []): void {
        if (engineVersion < 105) {
            return
        }
        writer.writeInt(this.PersonList.length)
        for (let i = 0; i < this.PersonList.length; i++) {
            this.PersonList[i]?.writeGameBin(writer)
        }
        writer.writeInt(fontSettings.length)
        for (let i = 0; i < fontSettings.length; i++) {
            fontSettings[i]?.writeGameBin(writer)
        }
    }
}
export default BubblePerson
